<template>
	<footer class="footer">
		<div class="footer-content">
			<div class="footer-content__main">
				<img
					class="footer-logo"
					src="@/assets/images/gzkx.png"
					alt=""
				/>
				<div class="footer-content__main-modules">
					<ul v-for="moudule in footerNavList" :key="moudule.path">
						<li>
							{{ moudule.title }}
						</li>
						<router-link
							tag="li"
							:to="child.path"
							v-for="child in moudule.children"
							:key="child.path"
						>
							{{ child.title }}
						</router-link>
					</ul>
				</div>
				<div class="footer-qrcode">
					<img src="@/assets/images/QRcode.png" alt="" />
					<p>关注中国科协广州科技园</p>
				</div>
			</div>
			<div class="footer-content__links">
				<span>友情链接：</span>
				<span
					v-for="link in friendlyLinks"
					:key="link.url"
					@click="onClickFriendlyLink(link.url)"
					>{{ link.name }}</span
				>
			</div>
			<div class="footer-content__records">
				<p>粤ICP备14047280号 工信部网站 {{ company }}版权所有</p>
			</div>
		</div>
	</footer>
</template>

<script>
import { mapState } from 'vuex'

export default {
	props: {},
	inject: ['navList'],
	data() {
		return {}
	},
	computed: {
		...mapState(['company']),
		footerNavList() {
			return this.navList.filter((nav) => nav.name !== 'Home')
		},
		friendlyLinks() {
			return [
				{
					name: '广州市科学技术局',
					url: 'http://kjj.gz.gov.cn/',
				},
				{
					name: '广东省科学技术厅',
					url: 'http://gdstc.gd.gov.cn/',
				},
				{
					name: '广州市发展和改革委员会',
					url: 'http://fgw.gz.gov.cn/',
				},
				{
					name: '广州市无线电集团',
					url: 'https://www.grg.cn/pc/sy/index.shtml',
				},
				{
					name: '广州开发区控股集团',
					url: 'http://www.getholdings.com.cn/',
				},
			]
		},
	},
	created() {},
	mounted() {},
	watch: {},
	methods: {
		onClickFriendlyLink(url) {
			url && window.open(url)
		},
	},
	components: {},
}
</script>

<style lang="scss">
.footer {
	background-color: #03327f;
	color: #fff;
	padding: 40px 0 15px 0;
	display: flex;
	justify-content: center;
	&-logo {
		width: 115px;
		height: 64px;
		object-fit: contain;
	}
	&-qrcode {
		font-size: 12px;
		text-align: center;
		color: rgba(255, 255, 255, 0.85);
		margin-right: 88px;
		img {
			width: 120px;
			height: 120px;
			object-fit: contain;
		}
	}
	&-content {
		flex-shrink: 0;
		&__main {
			display: flex;
			margin-bottom: 66px;
			&-modules {
				margin: 0 250px 0 60px;
				display: flex;
				flex: 1;

				& > ul + ul {
					margin-left: 60px;
				}
				& li:not(:first-child) {
					font-size: 14px;
					color: rgba(255, 255, 255, 0.85);
					margin-bottom: 10px;
					cursor: pointer;
				}
				& > ul li:first-child {
					font-size: 16px;
					color: #ffffff;
					margin-bottom: 20px;
				}
			}
		}
		&__links {
			font-size: 12px;
			margin-bottom: 15px;
			padding-bottom: 15px;
			color: rgba(255, 255, 255, 0.85);
			border-bottom: 1px solid rgba(255, 255, 255, 0.25);
			& > span {
				&:not(:first-child) {
					cursor: pointer;
				}
				margin-left: 10px;
			}
		}
		&__records {
			font-size: 12px;
			color: rgba(255, 255, 255, 0.85);
			text-align: center;
		}
	}
}
</style>
